export default "__VITE_ASSET__13c32c10__$_?nuxt_component=async__"